module.exports = __webpack_public_path__ + "48443a5cfebcacce84ef6e3591c7e9d7.png";